module.exports = __webpack_public_path__ + "fonts/google_ada90ebccbb52bdddef741dcc0bd8195.longcache.svg";